import { useEffect } from 'react';

export const useMetaTags = ({
  title = 'HTAG Facility | Assistance Numérique en Ardennes',
  description = 'HTAG Facility : Assistance numérique, design web, dépannage informatique et coaching digital pour PME, associations et collectivités en Ardennes (Château-Porcien)',
  keywords = 'assistance numérique, design web, dépannage informatique, coaching digital, Ardennes, Château-Porcien',
  url = 'https://htagfacility.fr',
  image = 'https://htagfacility.fr/og-image.png',
  type = 'website',
  locale = 'fr_FR'
} = {}) => {
  useEffect(() => {
    // Title
    document.title = title;

    // Meta tags
    const metaTags = [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: url },
      { property: 'og:type', content: type },
      { property: 'og:image', content: image },
      { property: 'og:locale', content: locale },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
      { name: 'theme-color', content: '#0090FF' },
      { name: 'robots', content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1' },
      { httpEquiv: 'X-UA-Compatible', content: 'IE=edge' }
    ];

    // Remove existing meta tags and add new ones
    metaTags.forEach(tagProps => {
      let selector = tagProps.property ? `meta[property="${tagProps.property}"]` : `meta[name="${tagProps.name || tagProps.httpEquiv}"]`;
      let existing = document.querySelector(selector);
      if (existing) {
        existing.remove();
      }

      const meta = document.createElement('meta');
      Object.keys(tagProps).forEach(key => {
        meta.setAttribute(key, tagProps[key]);
      });
      document.head.appendChild(meta);
    });

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.href = url;
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = url;
      document.head.appendChild(link);
    }

  }, [title, description, url, image, type, locale, keywords]);
};

export default useMetaTags;
